import { create as createOp, OP_TYPE } from './op';
import { create as createRel, RELATION_TYPE } from './relation';
export default {
  createOp,
  createRel,
  OP_TYPE,
  RELATION_TYPE
};